import { Checkbox } from "@/components/ui/baseUi/checkbox"
import { cn } from "@/modules/lib/utils"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { useProgramBundles } from "@modules/programBundle/hooks/useProgramBundle"
import { ProgramReductionItem } from "@modules/promoCode/components/programReductionItem"
import { Text } from "@/components/ui/baseUi/text"

type ProgramBundleListSelectionProps = {
  selectedProgramIds: string[]
  onSelectProgram: (id: string) => void
  onSelectAllPrograms: (allIds: string[]) => void
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  error?: React.JSX.Element
} & React.ComponentProps<"div">

export function ProgramBundleListSelection({
  selectedProgramIds,
  onSelectProgram,
  onSelectAllPrograms,
  promoCodeType,
  promoCodeValue,
  promoCodeDuration,
  error,
  className,
  ...props
}: ProgramBundleListSelectionProps) {
  const { data: programs } = useProgramBundles(null, true)

  if (programs.length === 0) return null

  return (
    <div className={cn(className, "flex flex-col gap-2")} {...props}>
      <Text fontStyle="LS" style={{ lineHeight: "21px", marginBottom: 7 }} className="mt-4 text-textDefault-body">
        {word("promoCode.form.input.relatedProgramBundle").toUpperCase()}
        <Text fontStyle="LL" className="text-red-500">
          {" *"}
        </Text>
      </Text>
      <div className="flex flex-col gap-2">
        <div className="mb-2 flex flex-row items-center justify-between">
          <Text fontStyle="LL">{word("global.filters.selectAll")}</Text>
          <Checkbox
            checked={programs.length === selectedProgramIds.length}
            onCheckedChange={() => {
              onSelectAllPrograms(programs.map((program) => program.id))
            }}
            className="size-5"
          />
        </div>

        {programs.map((program) => (
          <div key={program.id} className="flex flex-row items-center justify-between">
            <ProgramReductionItem
              key={program.id}
              program={program}
              promoCodeType={promoCodeType}
              promoCodeValue={promoCodeValue}
              promoCodeDuration={promoCodeDuration}
            />
            <Checkbox
              className="size-5 shrink-0"
              value={program.id}
              checked={selectedProgramIds.some((id) => id === program.id)}
              onCheckedChange={() => {
                onSelectProgram(program.id)
              }}
              data-testid={program.id}
            />
          </div>
        ))}

        {error}
      </div>
    </div>
  )
}
